export const detailsDescription = {
  optionalExtras: {
    header: 'Optional Extras',
    content: [
      {
        name: 'Theft',
        slug: 'theft',
        description: [
          'Covers you if your bicycle is stolen. Providers may have different levels of cover, e.g. theft from the home, away from the home or theft from a vehicle.',
        ],
      },
      {
        name: 'Public Liability',
        slug: 'publicLiability',
        description: [
          'Provides protection if you accidentally injure another person or damage third party property whilst riding your bicycle.',
        ],
      },
      {
        name: 'Personal accident',
        slug: 'accident',
        description: [
          'Provides compensation for you if you suffer a serious injury or death as a result of an accident whilst riding your bicycle.',
        ],
      },
      {
        name: 'Legal cover',
        slug: 'legal',
        description: [
          'In the event of an accident provides cover for legal expenses to assist with the recovery of uninsured losses.',
        ],
      },
      {
        name: 'Accessory cover',
        slug: 'accesories',
        description: [
          "Accessories are equipment added or fixed to the bicycle in addition to the manufacturer's specification.",
        ],
      },
      {
        name: 'Travel',
        slug: 'travel',
        description: [
          'Cover for your bicycle is extended to include European or Worldwide cover. Providers may have cover limits on the number of days for each trip, usually between 30 and 120 days. You can check your policy documents for these details, as well as a full list of countries covered under each provider.',
        ],
      },
      {
        name: 'Other things covered',
        slug: 'otherCovered',
      },
      {
        name: 'Other things available',
        slug: 'otherAvailable',
      },
    ],
    contentLimiter: 6,
  },
  estimatedPrice: {
    header: 'Estimated price with added extras*',
    subHeader: "This is an accurate price estimate for your quote with your selected optional extras, including interest and so it's possible prices may vary by a few pence on the provider's site. Please remember to check the final prices on the provider's site before purchasing your policy.",
  },
};
